// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__ZH2Mw","content":"styles_content__BbmhD","title":"styles_title__N2Ung","description":"styles_description__o1vCZ","tagList":"styles_tagList__4ynRy"};